// Default track fallback used across the application
export const DEFAULT_TRACK = 'TRACK1';

export const TRACK_NAMES = {
  'ALL': 'All Tracks',
  'TRACK1': 'Addition Facts',
  'TRACK2': 'Subtraction Facts',
  'TRACK3': 'Multiplication Facts',
  'TRACK4': 'Division Facts',
  'TRACK5': 'Division Facts (Up to 12)',
  'TRACK6': 'Addition Facts (Sums up to 20)',
  'TRACK7': 'Multiplication Facts (Factors up to 12)',
  'TRACK8': 'Subtraction Facts (Up to 20)',
  'TRACK9': 'Addition (Single-Digit)',
  'TRACK10': 'Subtraction (Single-Digit)',
  'TRACK11': 'Multiplication (Single-digit)',
  'TRACK12': 'Addition Within 10 (Sums up to 10)',
  'TRACK13': 'Addition Within 10 (Kindergarten)',
  'TRACK6_L2': 'Addition Facts (Sums up to 20) - Grade 5',
  'TRACK8_L2': 'Subtraction Facts (Up to 20) - Grade 5',
  'TRACK7_L2': 'Multiplication Facts (Factors up to 12) - Grade 5',
  'TRACK5_L2': 'Division Facts (Up to 12) - Grade 5',
  'TRACK_PREK_NAMING': 'Pre-K Number Naming (0-9)',
  'TRACK_PREK_SUBITIZING': 'Pre-K Subitizing (1-4)',
  'TRACK_PREK_COUNTING': 'Pre-K Counting (1-5)',
  'TRACK_PREK_WHATCOMESNEXT': 'Pre-K What Comes Next (1-5)',
  'TRACK_K_NAMING': 'K Number Naming (0-20)',
  'TRACK_K_SUBITIZING': 'K Subitizing (1-6)',
  'TRACK_K_COMPARING': 'K Comparing Numbers (1-10)',
  'TRACK_K_PARTWHOLE': 'K Part Whole Within 5 (0-5)',
  'TRACK_K_ADDITION_WITHIN_5': 'K Addition Within 5 (0-5)',
  'TRACK_K_ACCURACY': 'K Addition Accuracy Assessment'
} as const;

// Onboarding assessment sequence in grade progression order
export const ONBOARDING_ASSESSMENT_SEQUENCE = [
  'TRACK12', // G1 Add - Addition Within 10
  'TRACK9',  // G2 Add - Addition Single-Digit
  'TRACK10', // G2 Sub - Subtraction Single-Digit
  'TRACK6',  // G3 Add - Addition Facts up to 20
  'TRACK8',  // G3 Sub - Subtraction Facts up to 20
  'TRACK11', // G3 Mul - Multiplication Single-digit
  'TRACK7',  // G4 Mul - Multiplication Facts up to 12
  'TRACK5'   // G4 Div - Division Facts up to 12
] as const; 

export const TRACK_RANGES = {
  'TRACK1': [1, 99] as const,    // (Deprecated) Addition Facts
  'TRACK2': [100, 195] as const,   // (Deprecated) Subtraction Facts
  'TRACK3': [196, 279] as const,  // (Deprecated) Multiplication Facts
  'TRACK4': [280, 367] as const,  // (Deprecated) Division Facts
  'TRACK5': [368, 511] as const,  // Division Facts: Grades 4 and above
  'TRACK6': [512, 742] as const,  // Addition Facts: Grades 3 and above
  'TRACK7': [743, 911] as const,  // Multiplication Facts: Grades 4 and above
  'TRACK8': [912, 1142] as const,  // Subtraction Facts: Grades 3 and above
  'TRACK9': [1143, 1242] as const,  // Addition Facts: Grade 2 only
  'TRACK10': [1243, 1407] as const,  // Subtraction Facts: Grade 2 only
  'TRACK11': [1408, 1507] as const,  // Multiplication Facts: Grade 3 only
  'TRACK12': [1508, 1573] as const,  // Addition Facts: Grade 1 only
  'TRACK13': [1508, 1573] as const,  // Addition Facts: Kindergarten only
  'TRACK6_L2': [512, 742] as const,  // Same facts as TRACK6
  'TRACK8_L2': [912, 1142] as const,  // Same facts as TRACK8
  'TRACK7_L2': [743, 911] as const,  // Same facts as TRACK7
  'TRACK5_L2': [368, 511] as const,  // Same facts as TRACK5
  'TRACK_PREK_NAMING': [1574, 1583] as const,  // Pre-K Number Naming (digits 0-9)
  'TRACK_PREK_SUBITIZING': [1584, 1587] as const,   // Pre-K Subitizing (quantities 1-4)
  'TRACK_PREK_COUNTING': [1588, 1592] as const,   // Pre-K Counting (quantities 1-5)
  'TRACK_PREK_WHATCOMESNEXT': [1593, 1601] as const,   // Pre-K What Comes Next (1-9)
  'TRACK_K_NAMING': [1602, 1622] as const,  // K Number Naming (digits 0-20)
  'TRACK_K_SUBITIZING': [1623, 1628] as const,   // K Subitizing (quantities 1-6)
  'TRACK_K_COMPARING': [1629, 1678] as const,   // K Comparing Numbers (1-10)
  'TRACK_K_PARTWHOLE': [1679, 1684] as const,   // K Part Whole Within 5 (0-5)
  'TRACK_K_ADDITION_WITHIN_5': [1685, 1696] as const   // K Addition Within 5 (12 facts)
}

export const TRACK_LENGTHS = {
  'TRACK1': 99,
  'TRACK2': 96,
  'TRACK3': 84,
  'TRACK4': 88,
  'TRACK5': 144,
  'TRACK6': 231,
  'TRACK7': 169,
  'TRACK8': 231,
  'TRACK9': 100,
  'TRACK10': 165,
  'TRACK11': 100,
  'TRACK12': 66,
  'TRACK13': 66,
  'TRACK6_L2': 231,  // Same as TRACK6
  'TRACK8_L2': 231,  // Same as TRACK8
  'TRACK7_L2': 169,  // Same as TRACK7
  'TRACK5_L2': 144,  // Same as TRACK5
  'TRACK_PREK_NAMING': 10,  // Pre-K Number Naming (digits 0-9)
  'TRACK_PREK_SUBITIZING': 4,   // Pre-K Subitizing (quantities 1-4)
  'TRACK_PREK_COUNTING': 5,   // Pre-K Counting (quantities 1-5)
  'TRACK_PREK_WHATCOMESNEXT': 9,   // Pre-K What Comes Next (1-9)
  'TRACK_K_NAMING': 21,  // K Number Naming (digits 0-20)
  'TRACK_K_SUBITIZING': 6,   // K Subitizing (quantities 1-6)
  'TRACK_K_COMPARING': 50,   // K Comparing Numbers (1-10)
  'TRACK_K_PARTWHOLE': 6,   // K Part Whole Within 5 (0-5)
  'TRACK_K_ADDITION_WITHIN_5': 12   // K Addition Within 5 (12 facts)
};

// CQPM targets by grade (to be deprecated)
export const CQPM_TARGETS: { [key: number]: number } = {
  0: 30,
  1: 30,
  2: 30,
  3: 30,
  4: 35,
  5: 40,
  6: 40,
  7: 40,
  8: 40,
  9: 40,
  10: 40,
  11: 40,
  12: 40
};

// Accuracy threshold for passing PreK/K assessments (90%)
export const ACCURACY_PASS_THRESHOLD = 90;

// CQPM targets by track
export const CQPM_TARGETS_BY_TRACK = {
  'TRACK_PREK_NAMING': 12,  // Pre-K Number Naming (0-9) — analytics only, not used for pass/fail
  'TRACK_PREK_SUBITIZING': 8,  // Pre-K Subitizing (1-4) — analytics only, not used for pass/fail
  'TRACK_PREK_COUNTING': 8,   // Pre-K Counting (1-5) — analytics only, not used for pass/fail
  'TRACK_PREK_WHATCOMESNEXT': 10,  // Pre-K What Comes Next (1-9) — analytics only, not used for pass/fail
  'TRACK_K_NAMING': 18,  // K Number Naming (pass ≥ 18)
  'TRACK_K_SUBITIZING': 10,  // K Subitizing (pass ≥ 10)
  'TRACK_K_COMPARING': 14,  // K Comparing Numbers (pass ≥ 14)
  'TRACK_K_PARTWHOLE': 8,  // K Part Whole Within 5 (pass ≥ 8)
  'TRACK_K_ADDITION_WITHIN_5': 12,  // K Addition Within 5 (pass ≥ 12)
  'TRACK13': 20,      // Kindergarten
  'TRACK12': 30,      // Grade 1
  'TRACK9': 30,       // Grade 2
  'TRACK10': 30,      // Grade 2
  'TRACK11': 30,      // Grade 3
  'TRACK6': 30,       // Grade 3 - Level 1
  'TRACK8': 30,       // Grade 3 - Level 1
  'TRACK7': 35,       // Grade 4 - Level 1
  'TRACK5': 35,       // Grade 4 - Level 1
  'TRACK6_L2': 40,    // Grade 3 - Level 2
  'TRACK8_L2': 40,    // Grade 3 - Level 2
  'TRACK7_L2': 40,    // Grade 4 - Level 2
  'TRACK5_L2': 40     // Grade 4 - Level 2
} as const;

// Map of L1 tracks to their L2 counterparts
export const L1_TO_L2_MAP: Record<string, string> = {
  'TRACK6': 'TRACK6_L2',
  'TRACK8': 'TRACK8_L2',
  'TRACK7': 'TRACK7_L2',
  'TRACK5': 'TRACK5_L2'
};

// Final AlphaNumbers track for each FastMath grade/course. Completing one of
// these tracks hands progression to TimeBack, which assigns the external test
// before the student advances to the next course.
export const END_OF_GRADE_TRACKS = new Set<string>([
  'TRACK_PREK_WHATCOMESNEXT',
  'TRACK13',
  'TRACK12',
  'TRACK10',
  'TRACK11',
  'TRACK5',
  'TRACK5_L2',
  'TRACK4', // Legacy Grade 4 sequence
]);

// Fluency targets by grade
export const FLUENCY_TARGETS: { [key: number]: number } = {
  0: 2,
  1: 2,
  2: 2,
  3: 2,
  4: 1.5,
  5: 1.5,
  6: 1.5,
  7: 1.5,
  8: 1.5,
  9: 1.5,
  10: 1.5,
  11: 1.5,
  12: 1.5
};

// Mapping of tracks to grades
export const TRACK_TO_GRADE: Record<string, number> = {
  'TRACK1': 4,
  'TRACK2': 4,
  'TRACK3': 4,
  'TRACK4': 4,
  'TRACK_PREK_NAMING': -1,
  'TRACK_PREK_SUBITIZING': -1,
  'TRACK_PREK_COUNTING': -1,
  'TRACK_PREK_WHATCOMESNEXT': -1,
  'TRACK_K_NAMING': 0,
  'TRACK_K_SUBITIZING': 0,
  'TRACK_K_COMPARING': 0,
  'TRACK_K_PARTWHOLE': 0,
  'TRACK_K_ADDITION_WITHIN_5': 0,
  'TRACK_K_ACCURACY': 0,
  'TRACK13': 0,
  'TRACK12': 1,
  'TRACK9': 2,
  'TRACK10': 2,
  'TRACK6': 3,
  'TRACK8': 3,
  'TRACK11': 3,
  'TRACK7': 4,
  'TRACK5': 4,
  'TRACK5_L2': 5,
  'TRACK6_L2': 5,
  'TRACK7_L2': 5,
  'TRACK8_L2': 5,
};

// Grade display names
export const GRADE_DISPLAY_NAMES: Record<number, string> = {
  [-1]: 'Pre-K',
  0: 'Kindergarten',
  1: 'Grade 1',
  2: 'Grade 2',
  3: 'Grade 3',
  4: 'Grade 4',
  5: 'Grade 5',
};
